import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { Customer } from '@df/session/api/customer';
import { CustomerNotLoggedGuard } from '@df/session/customer/customer-not-logged.guard';
import { UiComponent } from '@df/ui/ui.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'login-view',
    template: '<router-outlet></router-outlet>',
    standalone: true,
    imports: [RouterOutlet]
})
export class LoginViewComponent extends UiComponent {
    protected metaRouterSubscription?: Subscription;

    constructor(
        protected customer: Customer,
        private meta: Meta,
        private customerNotLoggedGuard: CustomerNotLoggedGuard
    ) {
        super();
    }

    /**
     * On init hook to listen to customer mocdel status changes
     */
    override ngOnInit() {
        this.subscriptions.add(
            this.customer.model.obs.status.subscribe(() => {
                if (!this.customerNotLoggedGuard.isCustomerAllowed()) {
                    this.onLoggedInCheck();
                }
            })
        );
        super.ngOnInit();
    }

    onLoggedInCheck(): void {
        if (!this.customerNotLoggedGuard.isCustomerAllowed()) {
            if (this.meta.busy) {
                if (!this.metaRouterSubscription) {
                    this.metaRouterSubscription = this.meta.routerEvents.subscribe(() => this.onLoggedInCheck());
                }
            } else {
                this.customerNotLoggedGuard.onError();
            }
        } else {
            this.unsubscribeFromMetaRouter();
        }
    }

    /**
     * On destroy hook
     */
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.unsubscribeFromMetaRouter();
    }

    private unsubscribeFromMetaRouter(): void {
        if (this.metaRouterSubscription) {
            this.metaRouterSubscription.unsubscribe();
        }
    }
}
